require('./dist/angular-filter.js');
module.exports = 'angular.filter';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-filter/index.js
 ** module id = 2187
 ** module chunks = 2
 **/